// extracted by mini-css-extract-plugin
module.exports = {"message":"Message_message_2ZkU5","new":"Message_new_jfC6L","new_wrap":"Message_new_wrap_4_Vs5","label":"Message_label_exVca","label_wrap":"Message_label_wrap_1zJJE"};